export default __webpack_public_path__ + "static/media/backgroundDownload.91f103b5.png";